export const heroSlides = [
  {
    id: 1,
    title: '魔王之女',
    subtitle: '当魔王之女坠入凡间，命运的齿轮开始转动',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20dark%20fantasy%20illustration%20with%20elegant%20female%20character%20in%20flowing%20dress%20against%20a%20warm%20moonlit%20night%20sky%2C%20soft%20golden%20light%20rays%2C%20majestic%20castle%20silhouette%20in%20background%2C%20romantic%20anime%20manhwa%20style%2C%20rich%20warm%20amber%20and%20deep%20crimson%20tones%2C%20painterly%20texture%2C%20atmospheric%20and%20dramatic%20composition&width=1600&height=900&seq=hero-slide-01&orientation=landscape',
    category: '奇幻恋爱',
  },
  {
    id: 2,
    title: '剑与玫瑰',
    subtitle: '乱世之中，唯有剑与爱不可辜负',
    image: 'https://readdy.ai/api/search-image?query=A%20romantic%20historical%20fantasy%20illustration%20with%20warrior%20couple%20standing%20on%20cliff%20overlooking%20ancient%20kingdom%2C%20flowing%20robes%20in%20wind%2C%20soft%20sunset%20golden%20hour%20lighting%2C%20cherry%20blossom%20petals%20floating%2C%20manhwa%20anime%20art%20style%2C%20warm%20peach%20and%20rose%20color%20palette%2C%20dreamy%20atmospheric%20composition&width=1600&height=900&seq=hero-slide-02&orientation=landscape',
    category: '古风恋爱',
  },
  {
    id: 3,
    title: '星际恋曲',
    subtitle: '跨越星河的相遇，是命运最美的安排',
    image: 'https://readdy.ai/api/search-image?query=A%20futuristic%20romantic%20illustration%20of%20two%20figures%20reaching%20toward%20each%20other%20across%20a%20starry%20galaxy%20bridge%2C%20cosmic%20nebula%20in%20soft%20coral%20and%20gold%20hues%2C%20floating%20light%20particles%2C%20manhwa%20anime%20art%20style%2C%20dreamy%20ethereal%20atmosphere%2C%20gentle%20warm%20glow%2C%20romantic%20sci-fi%20composition&width=1600&height=900&seq=hero-slide-03&orientation=landscape',
    category: '科幻恋爱',
  },
];

export const featuredComics = [
  {
    id: 1,
    title: '魔王之女',
    author: '李智恩',
    category: '奇幻恋爱',
    rating: 9.5,
    chapters: 128,
    status: '连载中',
    description: '魔王唯一的女儿意外坠入人间，在一座古老城市里遇见了善良的少年。两个世界的碰撞，展开了一段跨越种族与命运的浪漫故事。',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20manhwa%20style%20illustration%20of%20elegant%20dark-haired%20female%20character%20with%20flowing%20gown%2C%20delicate%20features%2C%20soft%20moonlight%20illuminating%20her%20face%2C%20magical%20sparkles%20around%2C%20dark%20fantasy%20aesthetic%2C%20warm%20amber%20accents%2C%20clean%20simple%20background%2C%20romantic%20atmosphere&width=600&height=800&seq=comic-cover-01&orientation=portrait',
  },
  {
    id: 2,
    title: '剑与玫瑰',
    author: '朴星辰',
    category: '古风恋爱',
    rating: 9.3,
    chapters: 96,
    status: '连载中',
    description: '在动荡的古代王朝，身为女将军的她与敌国皇子之间，剑锋之下暗藏柔情，玫瑰与利剑交织的命运之歌。',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20manhwa%20style%20portrait%20of%20female%20warrior%20in%20traditional%20hanbok-inspired%20armor%2C%20holding%20sword%20with%20rose%2C%20gentle%20expression%2C%20soft%20petal-pink%20and%20warm%20background%2C%20elegant%20flowing%20hair%2C%20cherry%20blossom%20scattered%2C%20clean%20composition%2C%20romantic%20historical%20aesthetic&width=600&height=800&seq=comic-cover-02&orientation=portrait',
  },
  {
    id: 3,
    title: '星际恋曲',
    author: '金银河',
    category: '科幻恋爱',
    rating: 9.7,
    chapters: 85,
    status: '连载中',
    description: '公元 3025 年，人类已遍布银河系。一位地球考古学家在外星遗迹中唤醒了沉睡千年的外星王子，跨越星际的爱恋就此展开。',
    cover: 'https://readdy.ai/api/search-image?query=A%20futuristic%20manhwa%20style%20portrait%20of%20young%20woman%20with%20starry%20eyes%2C%20translucent%20galaxy-themed%20outfit%2C%20soft%20coral%20and%20gold%20nebula%20glow%2C%20gentle%20expression%2C%20floating%20light%20particles%2C%20clean%20scifi%20romantic%20aesthetic%2C%20dreamy%20atmosphere&width=600&height=800&seq=comic-cover-03&orientation=portrait',
  },
  {
    id: 4,
    title: '甜蜜陷阱',
    author: '崔美娜',
    category: '现代恋爱',
    rating: 9.4,
    chapters: 112,
    status: '连载中',
    description: '顶级甜点师与美食评论家之间的甜蜜对决，谁能想到最挑剔的评论家，竟是她失散多年的青梅竹马？',
    cover: 'https://readdy.ai/api/search-image?query=A%20sweet%20manhwa%20style%20illustration%20of%20cheerful%20female%20pastry%20chef%20in%20cute%20apron%2C%20holding%20decorated%20cake%2C%20bright%20smile%2C%20warm%20bakery%20background%20in%20soft%20cream%20and%20peach%20tones%2C%20romantic%20comedy%20vibe%2C%20clean%20charming%20portrait%2C%20delightful%20atmosphere&width=600&height=800&seq=comic-cover-04&orientation=portrait',
  },
  {
    id: 5,
    title: '暗夜守护者',
    author: '姜暗影',
    category: '悬疑恋爱',
    rating: 9.6,
    chapters: 74,
    status: '连载中',
    description: '拥有读心能力的私家侦探，接手了一桩离奇失踪案。案件的真相背后，隐藏着一个关于不朽爱情的惊天秘密。',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20manhwa%20style%20portrait%20of%20detective%20woman%20in%20trench%20coat%2C%20shadowy%20city%20night%20backdrop%2C%20intense%20gaze%2C%20single%20warm%20streetlamp%20light%2C%20film%20noir%20atmosphere%20with%20romantic%20undertone%2C%20soft%20amber%20light%20on%20face%2C%20clean%20composition%2C%20suspenseful%20yet%20elegant&width=600&height=800&seq=comic-cover-05&orientation=portrait',
  },
  {
    id: 6,
    title: '花语少女',
    author: '林花香',
    category: '治愈恋爱',
    rating: 9.2,
    chapters: 142,
    status: '连载中',
    description: '能听懂花语的高中女生，在一座神秘花店里开始了兼职工作。每朵花都有自己的故事，而她的故事正要开始。',
    cover: 'https://readdy.ai/api/search-image?query=A%20healing%20manhwa%20style%20portrait%20of%20gentle%20schoolgirl%20surrounded%20by%20colorful%20flowers%20in%20bloom%2C%20soft%20sunlight%20through%20window%2C%20peaceful%20warm%20expression%2C%20greenhouse%20background%2C%20soft%20pastel%20floral%20tones%2C%20clean%20heartwarming%20aesthetic%2C%20delicate%20and%20charming&width=600&height=800&seq=comic-cover-06&orientation=portrait',
  },
];

export const allComics = [
  ...featuredComics,
  {
    id: 7,
    title: '月下约定',
    author: '韩月影',
    category: '奇幻恋爱',
    rating: 9.1,
    chapters: 67,
    status: '连载中',
    description: '在满月之夜许下的约定，牵绊着两个世界的少女与狼族少年，跨越人兽界限的禁忌之恋。',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20manhwa%20style%20portrait%20of%20girl%20and%20wolf-boy%20under%20full%20moon%2C%20silver%20moonlight%2C%20magical%20forest%20background%2C%20warm%20silver%20and%20deep%20green%20tones%2C%20clean%20fantasy%20aesthetic%2C%20gentle%20atmosphere&width=600&height=800&seq=comic-cover-07&orientation=portrait',
  },
  {
    id: 8,
    title: '时光旅人',
    author: '郑时光',
    category: '奇幻恋爱',
    rating: 8.9,
    chapters: 53,
    status: '连载中',
    description: '拥有穿越时间能力的少女，为了拯救心爱之人，一次次回到过去，却发现每一次改变都带来无法预料的后果。',
    cover: 'https://readdy.ai/api/search-image?query=A%20dreamy%20manhwa%20style%20portrait%20of%20girl%20with%20pocket%20watch%2C%20swirling%20time%20motifs%2C%20vintage%20warm%20sepia%20tones%2C%20soft%20golden%20light%2C%20clean%20fantasy%20romance%20aesthetic%2C%20nostalgic%20atmosphere&width=600&height=800&seq=comic-cover-08&orientation=portrait',
  },
  {
    id: 9,
    title: '恋爱方程式',
    author: '赵心怡',
    category: '现代恋爱',
    rating: 9.3,
    chapters: 89,
    status: '连载中',
    description: '数学天才少女与校园篮球队长的奇妙化学反应，理性与感性的碰撞，如何用公式算出爱情？',
    cover: 'https://readdy.ai/api/search-image?query=A%20sweet%20manhwa%20style%20illustration%20of%20schoolgirl%20with%20glasses%20holding%20notebook%2C%20campus%20cherry%20blossom%20background%2C%20warm%20spring%20tones%2C%20clean%20romantic%20comedy%20aesthetic%2C%20charming%20youthful%20atmosphere&width=600&height=800&seq=comic-cover-09&orientation=portrait',
  },
  {
    id: 10,
    title: '仙界情缘',
    author: '慕容仙',
    category: '古风恋爱',
    rating: 9.0,
    chapters: 78,
    status: '连载中',
    description: '凡间少女误入仙界，与冷面仙君展开一段跨越仙凡之隔的绝世爱恋，天规与真情该如何抉择？',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20manhwa%20style%20illustration%20of%20girl%20in%20flowing%20traditional%20robes%20floating%20among%20clouds%2C%20celestial%20palace%20in%20distance%2C%20golden%20light%2C%20ethereal%20ancient%20Chinese%20fantasy%20aesthetic%2C%20clean%20elegant%20composition&width=600&height=800&seq=comic-cover-10&orientation=portrait',
  },
  {
    id: 11,
    title: '星际迷航',
    author: '宙行者',
    category: '科幻恋爱',
    rating: 9.2,
    chapters: 45,
    status: '连载中',
    description: '太空舰队女指挥官在未知星系中遇到了神秘的异星文明，一段超越物种界限的星际之恋。',
    cover: 'https://readdy.ai/api/search-image?query=A%20futuristic%20manhwa%20style%20portrait%20of%20female%20spaceship%20captain%20in%20sleek%20uniform%2C%20cosmic%20galaxy%20backdrop%2C%20warm%20coral%20and%20gold%20light%2C%20clean%20scifi%20romantic%20aesthetic%2C%20dramatic%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait',
  },
  {
    id: 12,
    title: '笑闹校园',
    author: '李乐乐',
    category: '搞笑恋爱',
    rating: 9.0,
    chapters: 156,
    status: '连载中',
    description: '转学生第一天就撞上了全校最难搞的校霸，谁知道校霸每次见到她就会脸红？欢喜冤家的爆笑日常。',
    cover: 'https://readdy.ai/api/search-image?query=A%20playful%20manhwa%20style%20illustration%20of%20energetic%20schoolgirl%20with%20laughing%20expression%2C%20campus%20background%2C%20warm%20bright%20colors%2C%20clean%20romantic%20comedy%20aesthetic%2C%20fun%20youthful%20atmosphere&width=600&height=800&seq=comic-cover-12&orientation=portrait',
  },
  {
    id: 13,
    title: '命运之轮',
    author: '金玄机',
    category: '剧情恋爱',
    rating: 9.4,
    chapters: 62,
    status: '连载中',
    description: '一位塔罗牌占卜师每次占卜都会预见顾客的未来恋情，直到有一天她预见了自己的命运。',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20manhwa%20style%20portrait%20of%20elegant%20female%20fortune%20teller%20with%20tarot%20cards%2C%20magical%20aura%2C%20warm%20golden%20and%20deep%20purple%20tones%2C%20clean%20dramatic%20composition%2C%20mystical%20romantic%20atmosphere&width=600&height=800&seq=comic-cover-13&orientation=portrait',
  },
  {
    id: 14,
    title: '阳光花店',
    author: '金阳光',
    category: '治愈恋爱',
    rating: 9.3,
    chapters: 108,
    status: '连载中',
    description: '在街角的一家小花店里，每个客人都带着心事而来。花店店主用鲜花治愈人心，却没想到自己的心事也需要被治愈。',
    cover: 'https://readdy.ai/api/search-image?query=A%20healing%20manhwa%20style%20portrait%20of%20gentle%20woman%20among%20flowers%20in%20cozy%20flower%20shop%2C%20soft%20afternoon%20sunlight%2C%20warm%20pastel%20tones%2C%20clean%20heartwarming%20aesthetic%2C%20peaceful%20atmosphere&width=600&height=800&seq=comic-cover-14&orientation=portrait',
  },
];

export const latestUpdates = [
  {
    id: 1,
    title: '魔王之女',
    latestChapter: '第128话 - 命运的抉择',
    updateTime: '2小时前',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20manhwa%20style%20illustration%20of%20dark-haired%20female%20character%20with%20determined%20expression%2C%20magical%20aura%20around%2C%20moonlit%20backdrop%2C%20dramatic%20shadows%2C%20warm%20golden%20accents%2C%20clean%20simple%20background%2C%20fantasy%20romance%20aesthetic&width=400&height=540&seq=latest-cover-01&orientation=portrait',
  },
  {
    id: 4,
    title: '甜蜜陷阱',
    latestChapter: '第112话 - 甜蜜的告白',
    updateTime: '5小时前',
    cover: 'https://readdy.ai/api/search-image?query=A%20cute%20manhwa%20style%20illustration%20of%20female%20baker%20blushing%20with%20flour%20on%20cheek%2C%20holding%20heart-shaped%20cookie%2C%20warm%20kitchen%20glow%2C%20soft%20peach%20and%20cream%20tones%2C%20clean%20romantic%20comedy%20vibe%2C%20charming%20portrait&width=400&height=540&seq=latest-cover-02&orientation=portrait',
  },
  {
    id: 2,
    title: '剑与玫瑰',
    latestChapter: '第96话 - 战场上的约定',
    updateTime: '8小时前',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20manhwa%20style%20portrait%20of%20female%20warrior%20in%20traditional%20armor%2C%20holding%20rose%2C%20sunset%20battlefield%20backdrop%2C%20warm%20golden%20skylight%2C%20romantic%20historical%20aesthetic%2C%20elegant%20composition%2C%20clean%20soft%20background&width=400&height=540&seq=latest-cover-03&orientation=portrait',
  },
  {
    id: 3,
    title: '星际恋曲',
    latestChapter: '第85话 - 星之记忆',
    updateTime: '12小时前',
    cover: 'https://readdy.ai/api/search-image?query=A%20dreamy%20manhwa%20style%20illustration%20of%20young%20woman%20floating%20among%20stars%2C%20ethereal%20expression%2C%20coral%20and%20gold%20cosmic%20glow%2C%20soft%20nebulae%20background%2C%20clean%20scifi%20romantic%20aesthetic%2C%20gentle%20atmosphere&width=400&height=540&seq=latest-cover-04&orientation=portrait',
  },
  {
    id: 5,
    title: '暗夜守护者',
    latestChapter: '第74话 - 真相浮现',
    updateTime: '1天前',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20manhwa%20style%20portrait%20of%20detective%20woman%20in%20shadow%2C%20single%20ray%20of%20warm%20light%2C%20rainy%20night%20city%2C%20film%20noir%20romantic%20vibe%2C%20amber%20streetlamp%20glow%2C%20clean%20composition%2C%20elegant%20mystery&width=400&height=540&seq=latest-cover-05&orientation=portrait',
  },
  {
    id: 6,
    title: '花语少女',
    latestChapter: '第142话 - 盛开的心意',
    updateTime: '1天前',
    cover: 'https://readdy.ai/api/search-image?query=A%20gentle%20manhwa%20style%20portrait%20of%20smiling%20schoolgirl%20holding%20sunflower%2C%20golden%20afternoon%20light%2C%20soft%20floral%20colors%2C%20warm%20healing%20atmosphere%2C%20clean%20charming%20aesthetic%2C%20heartwarming%20composition&width=400&height=540&seq=latest-cover-06&orientation=portrait',
  },
];

export const categories = [
  { id: 'fantasy-romance', name: '奇幻恋爱', icon: 'ri-magic-line', count: 325 },
  { id: 'historical-romance', name: '古风恋爱', icon: 'ri-ancient-gate-line', count: 218 },
  { id: 'modern-romance', name: '现代恋爱', icon: 'ri-heart-line', count: 456 },
  { id: 'scifi-romance', name: '科幻恋爱', icon: 'ri-rocket-line', count: 167 },
  { id: 'mystery-romance', name: '悬疑恋爱', icon: 'ri-search-eye-line', count: 143 },
  { id: 'healing-romance', name: '治愈恋爱', icon: 'ri-plant-line', count: 289 },
  { id: 'comedy-romance', name: '搞笑恋爱', icon: 'ri-emotion-laugh-line', count: 198 },
  { id: 'drama-romance', name: '剧情恋爱', icon: 'ri-movie-line', count: 312 },
];

export const rankings = [
  { rank: 1, title: '魔王之女', heat: '9,852,341', trend: 'up' },
  { rank: 2, title: '星际恋曲', heat: '9,671,289', trend: 'up' },
  { rank: 3, title: '暗夜守护者', heat: '8,945,672', trend: 'stable' },
  { rank: 4, title: '甜蜜陷阱', heat: '8,723,445', trend: 'up' },
  { rank: 5, title: '剑与玫瑰', heat: '8,451,902', trend: 'down' },
  { rank: 6, title: '花语少女', heat: '7,892,134', trend: 'up' },
  { rank: 7, title: '时光旅人', heat: '7,456,789', trend: 'stable' },
  { rank: 8, title: '月下约定', heat: '7,123,456', trend: 'down' },
];

export const siteStats = {
  totalComics: '12,580+',
  dailyVisitors: '850,000+',
  totalChapters: '3,200,000+',
  registeredUsers: '2,600,000+',
};